<template>
  <div ref="monitoringContent" class="security-system container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--卡片数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="数据列表" name="0">
            <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleFormQuery()">
              <el-form-item label="告警状态">
                <el-checkbox-group v-model="cardQueryParams.alarmStates">
                  <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                    {{alarmState.name}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleFormQuery()" type="primary">刷 新</el-button>
                <el-button @click="resetQueryForm()">重 置</el-button>
              </el-form-item>
              <el-form-item style="float:right">
                <span>总数</span><el-badge class="mark" :value="pageTotalCount" type="primary"/>
                <span>正常</span><el-badge class="mark" :value="pageNormalCount" type="success"/>
                <span>告警</span><el-badge class="mark" :value="pageAlarmCount" type="danger"/>
                <span>离线</span><el-badge class="mark" :value="pageErrorCount" type="info"/>
              </el-form-item>
            </el-form>
            <div class="general-container">
              <div class="card-container">
                <!--最大为3行-->
                <el-row style="margin-bottom: 20px" v-for="(rowItem, rowIndex) in cardMaxRowCount" :key="rowItem">
                  <!--每行4列-->
                  <el-col :span="24/cardMaxColCount" v-for="(colItem, colIndex) in cardMaxColCount" :key="colItem" :offset="0">
                    <el-card class="node-card" v-show="rowIndex*cardMaxColCount + colIndex < cardData.length">
                      <div slot="header" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;">
                        <span class="card-header-title" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardCurrentItem === cardData[rowIndex*cardMaxColCount + colIndex] ? 'active':''">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].name : ''}}
                        </span>
                        <el-button style="float: right;width:50px" type="text" @click="handleDataNodeView(cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null)">查看</el-button>
                      </div>
                      <div class="card-body-content" @click="cardCurrentItem = cardData[rowIndex*cardMaxColCount + colIndex];">
                        <div class="alarm-text-container">
                          <img class="alarm-icon" src="~@/assets/img/monitoring/security-system/ring.png" />
                          <span class="alarm-text" :class="cardData.length > rowIndex*cardMaxColCount + colIndex ? colorClassFromResourceAlarmState(cardData[rowIndex*cardMaxColCount + colIndex].resourceKind, cardData[rowIndex*cardMaxColCount + colIndex].alarmState, cardData[rowIndex*cardMaxColCount + colIndex].eventTypeSet, cardData[rowIndex*cardMaxColCount + colIndex].deployed, cardData[rowIndex*cardMaxColCount + colIndex].encoderAlarmState, cardData[rowIndex*cardMaxColCount + colIndex].encoderEventTypeSet) :''">
                          {{ cardData.length > rowIndex*cardMaxColCount + colIndex ? $type.getResourceAlarmStateText(cardData[rowIndex*cardMaxColCount + colIndex].resourceKind, cardData[rowIndex*cardMaxColCount + colIndex].alarmState, cardData[rowIndex*cardMaxColCount + colIndex].eventTypeSet, cardData[rowIndex*cardMaxColCount + colIndex].deployed, cardData[rowIndex*cardMaxColCount + colIndex].encoderAlarmState, cardData[rowIndex*cardMaxColCount + colIndex].encoderEventTypeSet) : ''}}
                          </span>
                        </div>
                        <div class="hint-text-container">
                          <span v-if="cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].alarmState === 1" class="hint-text">发生于：{{ cardData.length > rowIndex*cardMaxColCount + colIndex ? strDateTimeFromSTime_t(cardData[rowIndex*cardMaxColCount + colIndex].happenTime) : ''}}</span>
                          <span v-else-if="cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].alarmState === 0" class="hint-text">累计时长：{{ cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].strAlarmElapsedTime : ''}}</span>
                          <span v-else class="hint-text">累计时长：——</span>
                        </div>
                      </div>
                      <div class="card-body-footer">
                        <div class="button-container">
                          <el-button type="primary" class="footer-button" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleCancelAlarm();">
                          消警
                          </el-button>
                          <el-button class="footer-button" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleDeploy();">
                            {{cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].deployed ? '撤防':'布防'}}
                          </el-button>
                        </div>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
              <el-pagination v-show="cardTotalItem > cardQueryParams.pageSize"
                background
                @current-change="handleCurrentPageChange"
                :current-page.sync="cardQueryParams.pageNum"
                :page-size.sync="cardQueryParams.pageSize"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next, jumper"
                :total="cardTotalItem">
              </el-pagination>
              <div class="node-control-bar" :class="!footerOpen ? 'node-control-bar-side-close' : ''">
                <div class="node-control-bar-toggle-btn" @click="toggleFooter"></div>
                <div class="node-control-bar-left">
                  <a @click="handleDeploy" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon" :class="cardCurrentItem != null && cardCurrentItem.deployed ? 'undeploy':'deploy'"></span>{{cardCurrentItem != null && cardCurrentItem.deployed ? '撤防':'布防'}}
                  </a>
                  <a @click="handleCancelAlarm" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon cancel-alarm"></span>消警
                  </a>
                  <a @click="handleDeployAll" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon deploy-all"></span>全布防
                  </a>
                  <a @click="handleUndeployAll" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon undeploy-all"></span>全撤防
                  </a>
                  <a @click="handleCancelAllAlarms" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon cancel-all-alarms"></span>全消警
                  </a>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="组态画面" name="1">
            <map-navigator
              :defaultMapId="mapQueryParams.mapId"
              :defaultRegionId="mapQueryParams.regionId"
              :defaultSystemKind="mapQueryParams.systemKind"
              ref="mapNavigator"
            >
            </map-navigator>
          </el-tab-pane>
          <el-tab-pane label="事件记录" name="2">
            <el-form ref="eventQueryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleEventFormQuery()">
              <el-form-item label="告警状态" class="right-vertical-line pr15">
                <el-checkbox-group v-model="eventTableQueryParams.alarmStates">
                  <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                    {{alarmState.name}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="事件触发时间">
                <uni-date-range-picker
                  v-model="eventDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </uni-date-range-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleEventFormQuery()" type="primary">查 询</el-button>
                <el-button @click="resetEventQueryForm()">重 置</el-button>
              </el-form-item>
            </el-form>
            <div class="pagination-table-container">
              <el-table :data="eventTableData"
                        ref="eventTable"
                        border highlight-current-row
                        v-loading="loading"
                        element-loading-background="rgba(255, 255, 255, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="努力加载中..."
                        style="width: 100%"
                        @selection-change="handleEventTableSelectionChange"
                        @current-change="handleEventTableCurrentChange">
                <!--          <el-table-column type="selection" width="40"></el-table-column>-->
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
                </el-table-column>
                <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="告警状态" prop="alarmState" width="90">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                      {{scope.row.alarmStateText}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="告警级别" prop="alarmLevel" width="100">
                  <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>
                </el-table-column>
                <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
                <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
                <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
                <el-table-column label="事件触发时间" prop="happenTime" width="160">
                  <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
                </el-table-column>
                <el-table-column label="正常区间" prop="alarmRuleText" width="100"></el-table-column>
                <el-table-column label="确认状态" prop="handled" width="80">
                  <template slot-scope="scope">
                    <el-tag :type="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1) ? 'primary':'warning'">
                      {{(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1) ? '--' : getNameById(scope.row.handled, $type.handleStates)}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                  <template slot-scope="scope">
                    <el-button
                      class="col-btn"
                      type="text"
                      icon="el-icon-view"
                      @click="handleEventView(scope.row)"
                    >查看
                    </el-button>
                    <el-button
                      class="col-btn"
                      type="text"
                      icon="el-icon-s-check"
                      :disabled="scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1"
                      @click="handleEventHandle(scope.row)"
                    >确认
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination v-show="eventTableTotalRow > eventTableQueryParams.pageSize"
                             background
                             @current-change="handleEventCurrentPageChange"
                             @size-change="handleEventPageSizeChange"
                             :current-page.sync="eventTableQueryParams.pageNum"
                             :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                             :page-size.sync="eventTableQueryParams.pageSize"
                             prev-text="上一页"
                             next-text="下一页"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="eventTableTotalRow">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统计分析" name="3">
            <el-row type="flex">
              <el-col class="chart-container" :span="24">
                <div class="chart-title">告警次数排行</div>
                <bar
                  ref="alarmTimesRankingBar"
                  :id="alarmTimesRankingBarId"
                  :source="alarmTimesRankingBarData"
                  :color="alarmTimesRankingBarColor"
                  style="width:100%; height:240px"
                ></bar>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--显示数据节点信息-->
    <show-data-node v-if="showDataNodeModalOpen" :modalOpen="showDataNodeModalOpen" :dataNode="cardCurrentItem" @cancel="handleShowDataNodeModalCancel"></show-data-node>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showEventModalOpen" :modalOpen="showEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleShowEventModalSubmit" @cancel="handleShowEventModalCancel"></show-alarm-event>

    <!--确认告警事件弹窗-->
    <handle-alarm-event-Modal v-if="handelAlarmEventModalOpen" :modalOpen="handelAlarmEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleHandleAlarmEventModalSubmit" @cancel="handleHandleAlarmEventModalCancel"></handle-alarm-event-Modal>

  </div>
</template>

<script type="text/ecmascript-6">
import SecuritySystem from './SecuritySystem.js'

export default SecuritySystem
</script>

<style lang="scss">
  @import "SecuritySystem.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/securitySystem/SecuritySystem.vue